
import { ROUTES } from '@/constants'
import mustache from 'mustache'

import { SET_IS_LOADING_APP } from '@/store/mutation-types'
import { clientPageMixin } from '@/mixins'

import foFooter from '@/components/footer/footer.vue'
import foHeader from '@/components/header/header.vue'
import mixins from 'vue-typed-mixins'

export default mixins(clientPageMixin).extend({
  name: 'survey-confirmation',
  components: { foHeader, foFooter },
  data: () => ({
    hasLoaded: false,
  }),
  computed: {
    parsedContent(): string | undefined {
      if (this.clientPage?.config.customContent?.body) {
        return mustache.render(
          this.clientPage!.config.customContent?.body
            .replace(/<p>(.*?)<\/p>/gm, '$1')
            .replace(/&lt;/gm, '<')
            .replace(/&gt;/gm, '>')
            .replace(/&amp;/gm, '&')
            .replace(/&nbsp;/gm, ' ')
            .replace(/<br>/gm, ''),
        {},
        )
      }
    },
  },
  async beforeMount() {
    const {
      query: { language },
    } = this.$route

    const languageToUse = language?.toString() || ''

    await this.getClientPage(languageToUse)

    if (!this.clientPage || !this.delivery || this.delivery.status !== 'DELIVERY_OK') {
      return this.$router.push({ name: ROUTES.NOT_FOUND })
    }

    this.hasLoaded = true
  },
  mounted() {
    // remove loading app page
    this.$store.commit(SET_IS_LOADING_APP, false)
  },
})
